import numbro from 'numbro';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { WEATeacherPlanPrice } from '../../../constants/exchangeRates';
import { SVGIconType } from '../../../constants/svgIcon';
import { useSessionStore } from '../../../stores/SessionStore';
import { useUserStore } from '../../../stores/UserStore';
import { getLocalCurrencyById } from '../../../utils/region';
import { SvgIcon } from '../../Molecules';
import {
  BasicPopupContainer,
  PopUpButtonColors,
} from '../Containers/BasicPopupContainer';

import styles from './WEATeacherReferralRewardsInfoPopup.module.css';

type WEATeacherReferralRewardsInfoPopupProps = {
  onPrimary: () => void;
};

export const WEATeacherReferralRewardsInfoPopup = (
  props: WEATeacherReferralRewardsInfoPopupProps,
) => {
  const { t } = useTranslation();
  const { onPrimary } = props;
  const userId = useSessionStore((store) => store.activeUserId);
  const userProfile = useUserStore((state) => state.getProfile(userId ?? ''));
  const activeRegion = useSessionStore((store) => store.activeRegion);

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const currency = useMemo(() => {
    return userProfile?.localCurrency ?? getLocalCurrencyById(activeRegion);
  }, [activeRegion, userProfile?.localCurrency]);

  return (
    <BasicPopupContainer
      onPrimaryButtonClick={onPrimary}
      primaryButtonColor={PopUpButtonColors.WEA_PRIMARY}
    >
      <div className={styles.popupContent}>
        <SvgIcon
          name={SVGIconType.Referral}
          width={80}
          height={80}
          stroke="black"
        />

        <div className={styles.title}>{t('Referral Rewards')}</div>
        <div className={styles.infoBox}>
          <p className={styles.infoBoxTitle}>
            {t('Rewards Per Paid Membership Fee from Referred Users')}
          </p>
          <hr className={styles.divider} />
          <p>{t('Referral Reward:')}</p>
          <p className={styles.infoBoxRewardItem}>
            {t('1st Year')} -{' '}
            {`${currency}${numbro(
              WEATeacherPlanPrice[currency].tier1PurchaseReward,
            ).format({ thousandSeparated: true, mantissa: 2 })}`}
          </p>

          <p className={styles.infoBoxRewardItem}>
            {t('Afterwards')} -{' '}
            {`${currency}${numbro(
              WEATeacherPlanPrice[currency].tier2PurchaseReward,
            ).format({ thousandSeparated: true, mantissa: 2 })}`}
          </p>
        </div>
        <p className={styles.details}>
          {t('For details, please click this link.')}
          <br />
          <a href="https://app.joyajoy.com/wea-member/referral-detail">
            https://app.joyajoy.com/wea-member/referral-detail
          </a>
        </p>
      </div>
    </BasicPopupContainer>
  );
};
